import { render } from "./TheTaskForm.vue?vue&type=template&id=de4b4d0a&scoped=true"
import script from "./TheTaskForm.vue?vue&type=script&lang=js"
export * from "./TheTaskForm.vue?vue&type=script&lang=js"

import "./TheTaskForm.vue?vue&type=style&index=0&id=de4b4d0a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4b4d0a"]])

export default __exports__